/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

// on document ready
document.addEventListener('DOMContentLoaded', function () {
  // init swiper
  var swiper = new Swiper(".mySwiper", {
    direction: "vertical",
    effect: "fade",
    duration: 1000,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      prevEl: ".fa-chevron-up",
      nextEl: ".fa-chevron-down",
    },
    on: {
      afterInit: function () {
        const $nextButton = jQuery('.fa-chevron-up').detach();
        const $prevButton = jQuery('.fa-chevron-down').detach();
        const $pagination = jQuery('.swiper-pagination');

        $pagination.append($nextButton);
        $pagination.append($prevButton);
      }
    }
  });
});
